import Lib from '../../commons/lib';

export default class Service {
  static bufeUrl = window.location.origin + '/api/bufe/';

  static cikkUrl = window.location.origin + '/api/cikk/';

  static raktarUrl = window.location.origin + '/api/raktar/';

  static szemelyUrl = window.location.origin + '/api/szervezet/';

  static penzugykozosUrl = window.location.origin + '/api/penzugykozos/';

  static naptarUrl = window.location.origin + '/api/naptar/';

  // KÖZÖS TERMÉKCSOPORT START

  static listKozosCsoport(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'kozosbufe/listcsoport',
      args: { requestType: 'kozosbufe-listcsoport' }
    }], fnDone);
  }

  static addKozosCsoport(kozosCsoportObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.bufeUrl + 'kozosbufe',
      args: { requestType: 'kozosbufe-post' },
      data: kozosCsoportObj
    }], fnDone);
  }

  static editKozosCsoport(kozosCsoportModositObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.bufeUrl + 'kozosbufe',
      args: { requestType: 'kozosbufe-put' },
      data: kozosCsoportModositObj,
    }], fnDone);
  }

  static deleteKozosCsoport(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.bufeUrl + 'kozosbufe',
      args: { requestType: 'kozosbufe-delete' },
      params: { id: id }
    }], fnDone);
  }

  // KÖZÖS TERMÉKCSOPORT END

  // KÖZÖS TERMÉK START

  static listKozosTermek(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'kozosbufe/listtermek',
      args: { requestType: 'kozosbufe-listtermek' },
      params: { id: id }
    }], fnDone);
  }

  static addKozosTermek(kozosTermekObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.bufeUrl + 'kozosbufe/termek',
      args: { requestType: 'kozosbufe-termek-post' },
      data: kozosTermekObj
    }], fnDone);
  }

  static editKozosTermek(kozosTermekcsoportObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.bufeUrl + 'kozosbufe/termek',
      args: { requestType: 'kozosbufe-termek-put' },
      data: kozosTermekcsoportObj,
    }], fnDone);
  }

  static deleteKozosTermek(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.bufeUrl + 'kozosbufe/termek',
      args: { requestType: 'kozosbufe-termek-delete' },
      params: { id: id }
    }], fnDone);
  }

  // KÖZÖS TERMÉK END

  // BÜFÉ START

  static listBufek(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'bufe/list',
      args: { requestType: 'bufe-listbufe' },
    }], fnDone);
  }

  static listBufekSelect(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'bufe/list/select',
      args: { requestType: 'bufe-listbufeselect' },
    }], fnDone);
  }

  static addBufe(bufeObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.bufeUrl + 'bufe',
      args: { requestType: 'bufe-post' },
      data: bufeObj
    }], fnDone);
  }

  static editBufe(bufeObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.bufeUrl + 'bufe',
      args: { requestType: 'bufe-put' },
      data: bufeObj
    }], fnDone);
  }

  static deleteBufe(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.bufeUrl + 'bufe',
      args: { requestType: 'bufe-delete' },
      params: { id: id }
    }], fnDone);
  }

  static masolBufeTermekCsoport(termekCsoportMasolasBean, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.bufeUrl + 'termekcsoport/masol',
      args: { requestType: 'termekcsoport-masol' },
      data: termekCsoportMasolasBean
    }], fnDone);
  }

  static addBufeTermekCsoport(termekcsoportObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.bufeUrl + 'termekcsoport',
      args: { requestType: 'termekcsoport-post' },
      data: termekcsoportObj
    }], fnDone);
  }

  static addBufeTermekCsoport(termekcsoportObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.bufeUrl + 'termekcsoport',
      args: { requestType: 'termekcsoport-post' },
      data: termekcsoportObj
    }], fnDone);
  }

  static searchBufe(param, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'bufe/query',
      args: { requestType: 'bufe-query-get' },
      params: {
        param: param
      }
    }], fnDone);
  }

  static initTermekListaTab(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'termekcsoport/init',
      args: { requestType: 'termekcsoport-init' },
    }], fnDone);
  }

  static initBufeForm(insMod, id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'bufe/init',
      params: { insmod: insMod, id: id }
    }], fnDone);
  }

  static getArfolyam(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'bufe/arfolyam',
    }], fnDone);
  }

  // BÜFÉ END

  // KEDVEZMENYEK START

  static listDolgozoiKedvezmenyek(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'forgalom/szemelyekbufe',
      params: {
        bufeId: id
      }
    }], fnDone);
  }

  static listDolgozok(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'forgalom/szemelyekbufe',
      params: {
        bufeId: id
      }
    }], fnDone);
  }

  // KEDVEZMENYEK END

  // CIKK START

  static getAktivCikkek(text, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.cikkUrl + 'cikk/getaktiv',
      args: { requestType: 'cikk-getaktiv-get' },
      params: { text: text }
    }], fnDone);
  }

  static getCikk(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.cikkUrl + 'cikk',
      args: { requestType: 'cikk-get' },
      params: { id: id }
    }], fnDone);
  }

  static ListCikkek(param, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.cikkUrl + 'cikk/getcikk',
      args: { requestType: 'cikk-getcikk' },
      params: { param: param }
    }], fnDone);
  }

  static checkCikkekKeszleten(data, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.bufeUrl + 'forgalom/checkcikkekkeszleten',
      data: data
    }], fnDone);
  }

  static getFizetesiModok(fizetesiModAzonositok, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.bufeUrl + 'forgalom/init/fizmod',
      data: fizetesiModAzonositok
    }], fnDone);
  }

  // CIKK END

  // RAKTÁR START

  static getRaktars(text, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.raktarUrl + 'raktar/searchbytext',
      args: { requestType: 'raktar-searchbytext-get' },
      params: { text: text }
    }], fnDone);
  }

  static listRaktars(ids, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.raktarUrl + 'raktar/getnevekbyids',
      args: { requestType: 'raktar-getnevekbyids-get' },
      params: { ids: ids }
    }], fnDone);
  }

  // RAKTÁR END

  // TERMÉKCSOPORT START

  static listTermekCsoport(id, onlyAktiv, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'termekcsoport/list',
      params: {
        bufeid: id,
        allapot: onlyAktiv ? 'AKTIV' : null
      }
    }], fnDone);
  }

  static listTermekCsoportErtekesites(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'termekcsoport/list/ertekesites',
      args: { requestType: 'termekcsoport-list/ertekesites' },
      params: { bufeid: id }
    }], fnDone);
  }

  static listTermekCsoportSelect(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'termekcsoport/list/select',
      args: { requestType: 'termekcsoport-list/select' },
      params: { bufeid: id }
    }], fnDone);
  }

  static getTermekCsoport(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'termekcsoport',
      params: { id: id }
    }], fnDone);
  }

  static addTermekCsoport(termekcsoportObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.bufeUrl + 'termekcsoport',
      args: { requestType: 'termekcsoport-post' },
      data: termekcsoportObj
    }], fnDone);
  }

  static editTermekCsoport(termekcsoportModositObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.bufeUrl + 'termekcsoport',
      args: { requestType: 'termekcsoport-put' },
      data: termekcsoportModositObj,
    }], fnDone);
  }

  static deleteTermekCsoport(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.bufeUrl + 'termekcsoport',
      args: { requestType: 'termekcsoport-delete' },
      params: { id: id }
    }], fnDone);
  }

  static listTermekcsoportByBufe(bufeid, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'termekcsoport/listbybufeid',
      params: { bufeid: bufeid }
    }], fnDone);
  }

  static rendezTermekcsoport(array, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.bufeUrl + 'termekcsoport/rendez',
      args: { requestType: 'termekcsoport-rendez-put' },
      data: array
    }], fnDone);
  }

  static searchTermekcsoport(param, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'termekcsoport/query',
      args: { requestType: 'termekcsoport-query-get' },
      params: {
        param: param
      }
    }], fnDone);
  }

  // TERMÉKCSOPORT END

  // TERMÉK START

  static listTermekErtekesites(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'termek/list/ertekesites',
      params: {
        id: id,
      }
    }], fnDone);
  }

  static listTermek(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'termek/list',
      args: { requestType: 'termek-list' },
      params: { id: id }
    }], fnDone);
  }

  static getTermek(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'termek',
      params: { id: id }
    }], fnDone);
  }

  static addTermek(termekcsoportObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.bufeUrl + 'termek',
      args: { requestType: 'termek-post' },
      data: termekcsoportObj
    }], fnDone);
  }

  static editTermek(termekTortenetObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.bufeUrl + 'termek',
      args: { requestType: 'termek-put' },
      data: termekTortenetObj,
    }], fnDone);
  }

  static deleteTermek(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.bufeUrl + 'termek',
      args: { requestType: 'termek-delete' },
      params: { id: id }
    }], fnDone);
  }

  static deleteTermekTortenet(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.bufeUrl + 'termek/deletetortenetid',
      args: { requestType: 'termek-delete' },
      params: { id: id }
    }], fnDone);
  }

  static listTermekTortenet(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'termek/listtortenet',
      args: { requestType: 'termek-listtortenet' },
      params: { id: id }
    }], fnDone);
  }

  static listTermekByBufe(bufeid, tcsid, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'termek/listbybufeid',
      params: { bufeid, tcsid }
    }], fnDone);
  }

  static searchTermek(param, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'termek/query',
      args: { requestType: 'termek-query-get' },
      params: {
        param: param
      }
    }], fnDone);
  }

  static initNTAK(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'termek/init/ntak',
    }], fnDone);
  }

  static getKedvezmenyKategoriaToCalc(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'termek/init/kedvezmenykategoria',
    }], fnDone);
  }

  // TERMÉK END

  static searchCikk(cikk, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'termek/cikk',
      params: { nev: cikk }
    }], fnDone);
  }

  // FORGALOM START

  static insertForgalom(data, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.bufeUrl + 'forgalom',
      data: data,
    }], fnDone);
  }

  static listForgalomReszletes(forgalomBean, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.bufeUrl + 'forgalom/listforgalom2',
      args: { requestType: 'forgalom-listforgalom2-get' },
      data: forgalomBean
    }], fnDone);
  }

  static getUsersList(bufeid, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'forgalom/getuserslist',
      args: { requestType: 'forgalom-getuserslist' },
      params: {
        bufeid: bufeid
      }
    }], fnDone);
  }

  static listForgalomTetelek(forgalomid, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'forgalom/getforgalomtetelek',
      args: { requestType: 'forgalom-getforgalomtetelek' },
      params: {
        forgalomid: forgalomid
      }
    }], fnDone);
  }

  static listEladasok(filters, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'forgalom/eladaslista',
      args: { requestType: 'forgalom-eladaslista' },
      params: {
        kezdete: filters.kezdete,
        vege: filters.vege,
        bufeid: filters.bufeid,
        termekcsoportazon: filters.termekcsoportazon,
        termekcsoportnev: filters.termekcsoportnev,
        termekazon: filters.termekazon,
        termeknev: filters.termeknev
      }
    }], fnDone);
  }

  static getDistinctFizetesiMod(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'forgalom/listfizmod',
    }], fnDone);
  }

  // FORGALOM END

  // PENZUGY START

  static getDefaultCurrency(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugykozosUrl + 'penznem/defaultcurrency',
    }], fnDone);
  }
  
  static getAktivPenznemek(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugykozosUrl + 'penznem/aktiv',
    }], fnDone);
  }

  // PENZUGY END

  // NAPTAR START

  static getNaptarEsemenyTipusByHelyszin(helyszinId, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.naptarUrl + 'esemenytipus/list/helyszinid',
      params: {
        id: helyszinId
      }
    }], fnDone);
  }

  // NAPTAR END
}
